'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _classnames3 = require('classnames');

var _classnames4 = _interopRequireDefault(_classnames3);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _panelLocal = require('./panel.local.css');

var _panelLocal2 = _interopRequireDefault(_panelLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Header = function (_PureComponent) {
  _inherits(Header, _PureComponent);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, [{
    key: 'renderActionButton',
    value: function renderActionButton() {
      var action = this.props.action;

      if ((0, _isEmpty2.default)(action)) {
        return '';
      }

      return _react2.default.createElement('button', {
        className: _panelLocal2.default.actionButton,
        onClick: function onClick() {
          return action.onClick();
        }
      }, _react2.default.createElement('span', {
        className: _panelLocal2.default.actionButtonContent
      }, action.icon && _react2.default.createElement(_icon2.default, {
        icon: action.icon,
        className: _panelLocal2.default.actionButtonIcon,
        color: 'currentColor'
      }), _react2.default.createElement('span', {
        className: _panelLocal2.default.actionLabel
      }, action.label)));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          isCollapsed = _props.isCollapsed,
          toggleCollapse = _props.toggleCollapse,
          disableCollapse = _props.disableCollapse,
          className = _props.className;
      return _react2.default.createElement('div', {
        className: (0, _classnames4.default)(_panelLocal2.default.sectionHeaderWrapper, className),
        'aria-expanded': !isCollapsed
      }, _react2.default.createElement('button', {
        className: (0, _classnames4.default)(_panelLocal2.default.sectionHeaderButton, _defineProperty({}, _panelLocal2.default.collapsed, isCollapsed), _defineProperty({}, _panelLocal2.default.disableCollapse, disableCollapse)),
        onClick: function onClick(e) {
          e.preventDefault();

          if (!disableCollapse) {
            toggleCollapse();
          }
        },
        'data-toggle': 'collapse'
      }, children, !disableCollapse && _react2.default.createElement(_icon2.default, {
        'data-auto': 'caret',
        className: _panelLocal2.default.caret,
        color: 'currentColor',
        icon: 'selection',
        size: 'small',
        rotate: isCollapsed ? 90 : 180
      })), this.renderActionButton());
    }
  }]);

  return Header;
}(_react.PureComponent);

Header.defaultProps = {
  action: {},
  disableCollapse: false,
  toggleCollapse: function toggleCollapse() {},
  className: null
};
Header.propTypes = {
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string,
  isCollapsed: _propTypes2.default.bool.isRequired,
  action: _propTypes2.default.shape({
    icon: _propTypes2.default.string,
    label: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    id: _propTypes2.default.any
  }).isRequired,
  disableCollapse: _propTypes2.default.bool,
  toggleCollapse: _propTypes2.default.func
};
exports.default = Header;